import { useTheme } from '@mui/material'

interface ILockIconProps {
  className?: string
}

const LockIcon = ({ className }: ILockIconProps) => {
  const theme = useTheme()

  return (
    <svg
      width="16"
      height="20"
      className={className}
      viewBox="0 0 16 20"
      xmlns="http://www.w3.org/2000/svg"
      fill={theme.palette.custom.darkBlue2}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 5V8H2C0.931649 8 0 8.77637 0 9.83333V18.1667C0 19.2236 0.931649 20 2 20H14C15.0684 20 16 19.2236 16 18.1667V9.83333C16 8.77637 15.0684 8 14 8H13V5C13 2.23858 10.7614 0 8 0C5.23858 0 3 2.23858 3 5ZM11 5V8H5V5C5 3.34315 6.34315 2 8 2C9.65685 2 11 3.34315 11 5ZM2 18V10H14V18H2ZM9 14C9 14.5523 8.55229 15 8 15C7.44772 15 7 14.5523 7 14C7 13.4477 7.44772 13 8 13C8.55229 13 9 13.4477 9 14Z"
      />
    </svg>
  )
}

export { LockIcon }
